export const communicationLogs_LABELS = {
  logId: "Log ID",
  communicationType: "Type",
  clinicName: "Clinic Name",
  bpSiteId: "BP Site ID",
  finalisedBy: "Finalised By",
  recipientName: "Recipient's Name",
  recipientType: "Recipient's Type",
  recipientAddress: "Contact Details",
  status: "Status",
  initiatedBy: "Initiated By",
  documentsSent: "Documents Sent",
  eligibilityType: "Eligibility Type",
  reason: "Reason",
  date: "Date",
  actions: "Actions",
  recipientAddressHelpText:
    "An email or fax will be sent to the recipient address below. Make sure to provide the correct details.",
  patientName: "Patient's Name",
};
